var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"miniStyle miniMap",attrs:{"placeholder":"请选择","size":"mini"},on:{"change":_vm.openMap},model:{value:(_vm.mapdata),callback:function ($$v) {_vm.mapdata=$$v},expression:"mapdata"}},_vm._l((_vm.mapList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.elevation}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }